import React, { useState } from 'react'
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'react-headless-accordion'
import { IoIosArrowBack } from 'react-icons/io'
import 'aos/dist/aos.css'

const Accordions = ({ phoneNumber, email, days, hours }) => {
  function formatIsraeliPhoneNumber(phoneNumber) {
    // Remove all non-digit characters from the phone number
    const cleanedNumber = phoneNumber.replace(/\D/g, '')

    // Check if the number starts with "972" and remove it if present
    const formattedNumber = cleanedNumber.startsWith('972') ? cleanedNumber.slice(3) : cleanedNumber

    // Insert dashes in the appropriate places and add a leading "0"
    const formattedWithZero = `0${formattedNumber.slice(0, 2)}-${formattedNumber.slice(2, 5)}-${formattedNumber.slice(
      5,
    )}`

    return formattedWithZero
  }

  const handleClick = () => {
    window.location.href = `mailto:${email}`
  }

  var formattedPhoneNumber = formatIsraeliPhoneNumber(phoneNumber)

  const [rotationStates, setRotationStates] = useState({})

  const toggleRotation = (accordionIndex) => {
    setRotationStates((prevState) => ({
      ...prevState,
      [accordionIndex]: !prevState[accordionIndex],
    }))
  }

  const accordionTransitionDuration = 800 // Set the same duration as the accordion transition

  return (
    <div className="py-8 ">
      <div className="max-w-[450px] pb-8 card border-transparent bg-transparent  mx-auto">
        <div>
          <Accordion
            className="hover:opacity-95 card bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-4 border-borderBtn text-2xl font-semibold p-4 m-4 shadow-lg"
            transition={{
              duration: `${accordionTransitionDuration}ms`,
              timingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
            }}
          >
            <AccordionItem>
              <AccordionHeader className="items-center flex justify-between" onClick={() => toggleRotation(1)}>
                <IoIosArrowBack
                  className={rotationStates[1] ? 'rotate-90' : ''}
                  style={{ transition: `transform 0.4s ease-in-out` }}
                />
                <h3 className={`accordion-title  gold-text`}>סלטים</h3>
              </AccordionHeader>

              <AccordionBody className="card-normal text-accordionText">
                <div className="accordion-body">
                  <div className="card shadow-xl mx-auto text-right ">
                    <div className="text-right p-4">
                      <li className="font-medium text-base mb-1 mt-1" dir="rtl">
                        חומוס ביתי
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        טחינה לבנה
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        פלפל חריף מטוגן בתחמיץ
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        גזר חי בלימון
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        גזר מרוקאי
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        מטבוחה
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        סלט ירקות חי
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        חמוצי הבית טורשי
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        סלט סלק
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        תפו"א במיונז
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        חציל במיונז
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        חציל בטחינה
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        חציל מטוגן בתחמיץ
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        זעלוק - חציל ופלפים קלויים
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        כרוב בחמוציות
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        קולסואו (כרוב במיונז)
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        מלפפון בשמיר
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        חסה בייבי עם ירקות
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        סלט טאבולה
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        סלט בטטה
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        סלט תירס ופטריות במיונז
                      </li>
                    </div>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <Accordion
            className="hover:opacity-95 card bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-4 border-borderBtn text-2xl font-semibold p-4 m-4 shadow-lg"
            transition={{
              duration: `${accordionTransitionDuration}ms`,
              timingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
            }}
          >
            <AccordionItem>
              <AccordionHeader className="items-center flex justify-between" onClick={() => toggleRotation(2)}>
                <IoIosArrowBack
                  className={rotationStates[2] ? 'rotate-90' : ''}
                  style={{ transition: `transform 0.4s ease-in-out` }}
                />
                <h3 className={`accordion-title  gold-text`}>מנות ראשונות</h3>
              </AccordionHeader>

              <AccordionBody className="card-normal text-accordionText">
                <div className="accordion-body">
                  <div className="card shadow-xl mx-auto text-right ">
                    <div className="text-right p-4">
                      <li className="font-medium text-base mb-1" dir="rtl">
                        טורטיה בשר / עוף / צמחוני
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        מושט עשבי תיבול / מרוקאי / מטוגן
                      </li>
                      {/* <p className='font-bold text-lg my-2 gold-text' dir='rtl'>+ 10 ש"ח</p> */}
                      <li className="font-medium text-base mb-1" dir="rtl">
                        סלמון בלימון ועשבי תיבול
                        <span className="font-bold text-sm my-2 gold-text" dir="rtl">
                          {' '}
                          + 20 ש"ח
                        </span>
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        סלמון מרוקאי
                        <span className="font-bold text-sm my-2 gold-text" dir="rtl">
                          {' '}
                          + 20 ש"ח
                        </span>
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        סלמון טריאקי ושומשום
                        <span className="font-bold text-sm my-2 gold-text" dir="rtl">
                          {' '}
                          + 20 ש"ח
                        </span>
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        סלמון פסטו
                        <span className="font-bold text-sm my-2 gold-text" dir="rtl">
                          {' '}
                          + 20 ש"ח
                        </span>
                      </li>
                      {/* <li className='font-medium text-base mb-1' dir='rtl'>טורטיה בקר</li> */}
                    </div>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <Accordion
            className="hover:opacity-95 card bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-4 border-borderBtn text-2xl font-semibold p-4 m-4 shadow-lg"
            transition={{
              duration: `${accordionTransitionDuration}ms`,
              timingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
            }}
          >
            <AccordionItem>
              <AccordionHeader className="items-center flex justify-between" onClick={() => toggleRotation(3)}>
                <IoIosArrowBack
                  className={rotationStates[3] ? 'rotate-90' : ''}
                  style={{ transition: `transform 0.4s ease-in-out` }}
                />
                <h3 className={`accordion-title  gold-text`}>פשטידות</h3>
              </AccordionHeader>

              <AccordionBody className="card-normal text-accordionText">
                <div className="accordion-body">
                  <div className="card shadow-xl mx-auto text-right ">
                    <div className="text-right p-4">
                      <li className="font-medium text-base mb-1" dir="rtl">
                        פשטידה מרוקאית
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        פשטידת ירקות
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        פשטידת פטריות ובצל
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        קוגל תפו"א
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        קוגל אטריות
                      </li>
                    </div>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <Accordion
            className="hover:opacity-95 card bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-4 border-borderBtn text-2xl font-semibold p-4 m-4 shadow-lg"
            transition={{
              duration: `${accordionTransitionDuration}ms`,
              timingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
            }}
          >
            <AccordionItem>
              <AccordionHeader className="items-center flex justify-between" onClick={() => toggleRotation(4)}>
                <IoIosArrowBack
                  className={rotationStates[4] ? 'rotate-90' : ''}
                  style={{ transition: `transform 0.4s ease-in-out` }}
                />
                <h3 className={`accordion-title  gold-text`}>מנות עקריות</h3>
              </AccordionHeader>

              <AccordionBody className="card-normal text-accordionText">
                <div className="accordion-body">
                  <div className="card shadow-xl mx-auto text-right ">
                    <div className="text-right p-4">
                      <li className="font-medium text-base mb-1" dir="rtl">
                        שניצל עוף
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        כרעיים מזרחי / טריאקי
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        כרעיים מרקש
                        <span className="text-sm" dir="rtl">
                          {' '}
                          (כוסברה בצל וקינמון)
                        </span>
                      </li>
                      {/* <li className='font-medium text-base mb-1' dir='rtl'>שוקיים עוף מצופות</li> */}
                      <li className="font-medium text-base mb-1" dir="rtl">
                        פילה עוף בטמפורה
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        אסאדו ברוטב ברביקיו
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        אסאדו אפוי עם רוטב ירקות שורש
                      </li>

                      <li className="font-medium text-base mb-1" dir="rtl">
                        גונדי
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        מוקפץ בקר וירקות ברוטב סצוואן
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        קציצות קבב על האש
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        מוקפץ עוף וירקות בטריאקי
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        קוביות בקר מרוקאי עם חומוס
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        קוביות בקר עם שעועית לבנה
                      </li>

                      {/* <p className='font-bold text-lg my-2 gold-text' dir='rtl'>בתוספת תשלום:</p> */}
                      <li className="font-medium text-base mb-1" dir="rtl">
                        קציצות בקר עם אפונה
                      </li>

                      <li className="font-medium text-base mb-1" dir="rtl">
                        סטייק פרגית על האש{' '}
                        {/* <span
                          className="font-bold text-sm my-2 gold-text"
                          dir="rtl"
                        >
                          + 10 ש"ח
                        </span> */}
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        פרגיות ממולאות{' '}
                        {/* <span
                          className="font-bold text-sm my-2 gold-text"
                          dir="rtl"
                        >
                          + 10 ש"ח
                        </span> */}
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        צלי בקר ברוטב פטריות{' '}
                        <span className="font-bold text-sm my-2 gold-text" dir="rtl">
                          + 10 ש"ח
                        </span>
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        צלי בקר אסייתי{' '}
                        <span className="font-bold text-sm my-2 gold-text" dir="rtl">
                          + 10 ש"ח
                        </span>
                      </li>
                    </div>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <Accordion
            className="hover:opacity-95 card bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-4 border-borderBtn text-2xl font-semibold p-4 m-4 shadow-lg"
            transition={{
              duration: `${accordionTransitionDuration}ms`,
              timingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
            }}
          >
            <AccordionItem>
              <AccordionHeader className="items-center flex justify-between" onClick={() => toggleRotation(5)}>
                <IoIosArrowBack
                  className={rotationStates[5] ? 'rotate-90' : ''}
                  style={{ transition: `transform 0.4s ease-in-out` }}
                />
                <h3 className={`accordion-title  gold-text`}>תוספות</h3>
              </AccordionHeader>

              <AccordionBody className="card-normal text-accordionText">
                <div className="accordion-body">
                  <div className="card shadow-xl mx-auto text-right ">
                    <div className="text-right p-4">
                      <li className="font-medium text-base mb-1" dir="rtl">
                        אורז לבן / אושפלוב
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        אורז צהוב אפונה ושמיר
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        אורז אסייתי עם ירקות
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        תפו"א אפוי / רוזמרין / דואט בטטה
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        זיתים מרוקאים
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        אפונה וגזר
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        שעועית ירוקה ברוטב / מוקפצת בטריאקי
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        גזר (צימעס)
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        אפונה וארטישוק ברוטב
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        קוסקוס
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        מרק ירקות עשיר לקוסקוס
                      </li>
                    </div>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <Accordion
            className="hover:opacity-95 card bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-4 border-borderBtn text-2xl font-semibold p-4 m-4 shadow-lg"
            transition={{
              duration: `${accordionTransitionDuration}ms`,
              timingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
            }}
          >
            <AccordionItem>
              <AccordionHeader className="items-center flex justify-between" onClick={() => toggleRotation(6)}>
                <IoIosArrowBack
                  className={rotationStates[6] ? 'rotate-90' : ''}
                  style={{ transition: `transform 0.4s ease-in-out` }}
                />
                <h3 className={`accordion-title  gold-text`}>שירות</h3>
              </AccordionHeader>

              <AccordionBody className="card-normal text-accordionText">
                <div className="accordion-body">
                  <div className="card shadow-xl mx-auto text-right ">
                    <div className="text-right p-4">
                      <li className="font-medium text-base mb-1" dir="rtl">
                        לחמניות{' '}
                        <span className="font-bold text-sm my-2 gold-text" dir="rtl">
                          {' '}
                          - 3 ש"ח אדם
                        </span>
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        כוס, צלחת, סכום, קערות לתוספות, <br />
                        קערות לסלטים, מפיות{' '}
                        <span className="font-bold text-sm my-2 gold-text" dir="rtl">
                          {' '}
                          - 8 ש"ח אדם
                        </span>
                      </li>
                      <li className="font-medium text-base mb-1" dir="rtl">
                        שתייה מגוונת
                        <span className="font-bold text-sm my-2 gold-text" dir="rtl">
                          {' '}
                          - 10 ש"ח אדם
                        </span>
                      </li>
                      {/* <li className='font-medium text-base mb-1' dir='rtl'>כלים חד"פ <span className='font-bold text-sm my-2 gold-text' dir='rtl'> - 8 ש"ח אדם</span></li> */}
                      {/* <li className='font-medium text-base mb-1' dir='rtl'>כלים פורצלן <span className='font-bold text-sm my-2 gold-text' dir='rtl'> - 25 ש"ח אדם</span></li> */}

                      <li className="font-medium text-base mb-1" dir="rtl">
                        משלוח מרוחק
                        <span className="font-bold text-sm my-2 gold-text" dir="rtl">
                          {' '}
                          - 250 ש"ח{' '}
                        </span>
                      </li>
                    </div>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          {/* <div dir="rtl" className="text-center text-white mt-8">
            *המחירים לא כוללים מע"מ
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default Accordions
